import { entity } from 'jsonapi-transformers';

import { HierarchyNode } from './hierarchy-node';

@entity({ type: 'faculties' })
export class Faculty extends HierarchyNode {}
